//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { API } from 'aws-amplify'
import { isUsingNewLayout } from '~/utils/isUsingNewLayout'
import getMentorData from '~/gql/getMentorData'
import getNextMentor from '~/gql/getNextMentor'
export default {
  name: 'UserProfile',
  meta: {
    name: 'UserProfile',
    mentorOnly: true,
    headerBack: {
      backUrl: '/dashboard',
      showEditButton: true,
    },
    group: 'userProfile',
    icon: 'user',
  },
  async asyncData({
    store,
    params,
    $forumApi,
    $graphcms,
    $localeResolver,
    app,
  }) {
    store.commit('global/setTheme', 'red')
    const nickname = params?.user
    if (nickname) {
      const { data } = await API.get(
        'api',
        `/mentor/getUserByNickname?nickname=${nickname}`
      )
      // if graphcmsId is empty, this user is not a mentor, except when the profile the user is calling is his own
      if (data?.graphcmsId || app.$auth?.user?.nickname === data?.nickName) {
        const topics = await $forumApi.getTopicsByUserId(data?.forumId)
        const posts = await $forumApi.getPostsByUserId(data?.forumId)
        const { mentor } = await $graphcms.request(getMentorData, {
          lang: [app.i18n.locale],
          id: data.graphcmsId,
        })
        // mentors speaking same language
        const { mentors } = await $graphcms.request(getNextMentor, {
          lang: [app.i18n.locale],
          id: mentor?.id,
          speakingLanguages: mentor?.speakingLanguages,
        })

        const { data: dataAllMentors } = await API.get('api', '/mentor/getAll')

        let nextMentorData = {}
        for (const gcmsMentor of mentors) {
          const matchingDbMentor = dataAllMentors.find(
            (dbMentor) =>
              dbMentor.graphcmsId === gcmsMentor.id && dbMentor.avatarUrl
          )

          if (matchingDbMentor) {
            nextMentorData = matchingDbMentor
            break
          }
        }
        // @todo reading list+

        const subline = mentor?.implantType ? mentor.implantType[0] : ''
        const profile = {
          id: mentor?.id ? mentor.id : data.id,
          title: mentor?.title ? mentor.title : data.firstName,
          firstName: mentor?.title ? mentor.title : data.firstName,
          lastName: mentor?.lastName ? mentor.lastName : data.lastName,
          avatar: {
            src: data.avatarUrl,
            alt: `Avatar ${mentor?.title ? mentor.title : data.firstName}`,
          },
          location: mentor?.location,
          nickName: data?.nickName,
          languages: mentor?.speakingLanguages,
          forum: { topics, posts },
          forumId: data?.forumId,
          subline,
          gender: mentor?.gender ? mentor?.gender : '',
          text:
            mentor?.hearingJourneyNew && mentor.hearingJourneyNew.length === 0
              ? mentor.text?.html
              : '',
          hearingJourneyNew: mentor?.hearingJourneyNew
            ? mentor.hearingJourneyNew
            : [],
          shortDescription: mentor?.shortDescription,
          videoLink: mentor?.videoLink,
          avatarForVideo: mentor?.avatarForVideo
            ? mentor?.avatarForVideo.url
            : data.avatarUrl,
          videoThumbnail: mentor?.videoThumbnail,
          aboutMentor: mentor?.aboutMentor,
          implantType: mentor?.implantType,
          nextMentor: nextMentorData,
          whatsappNumber: mentor?.whatsappNumber,
        }

        return {
          profile,
        }
      } else {
        app.router.push($localeResolver.localePath({ path: '/dashboard' }))
      }
    } else {
      app.router.push($localeResolver.localePath({ path: '/connect' }))
    }
  },
  data() {
    return {
      sidebar: [],
      cta: { title: '' },
      topics: { title: '' },
      avatar: '',
      illustrations: [
        {
          number: 1,
          src: require(`~/assets/img/element-hear-03.svg?data`),
          width: 275,
          height: 262,
          alt: '',
        },
        {
          number: 2,
          src: require(`~/assets/img/element-learn-06.svg?data`),
          width: 222,
          height: 457,
          alt: '',
        },
        {
          number: 3,
          src: require(`~/assets/img/element-learn-06.svg?data`),
          width: 222,
          height: 457,
          alt: '',
        },
        {
          number: 4,
          src: require(`~/assets/img/element-hear-03.svg?data`),
          width: 275,
          height: 262,
          alt: '',
        },
        {
          number: 5,
          src: require(`~/assets/img/element-learn-02.svg?data`),
          width: 119,
          height: 141,
          alt: '',
        },
        {
          number: 6,
          src: require(`~/assets/img/element-connect-07.svg?data`),
          width: 143,
          height: 113,
          alt: '',
        },
      ],
    }
  },
  computed: {
    isUsingNewLayout() {
      return isUsingNewLayout(this.$i18n.locale)
    },
  },
  methods: {
    openMentorsForm() {
      if (this.userBranch === '') {
        console.log('matomo disabled for local environments')
      } else {
        // eslint-disable-next-line no-undef
        const currentPageURL = window.location.href
        // eslint-disable-next-line no-undef
        window._mtm = window._mtm || []
        // eslint-disable-next-line no-undef
        window._mtm.push({
          event: 'get-in-touch-form-submission-start',
          'event-category': 'get-in-touch-form-submission',
          'event-action': `CLICK_LINK_URL - ${currentPageURL}`,
        })
      }

      this.$store.commit('global/setDialog', {
        dialog: 'contact-mentor',
        layer: true,
        props: {
          focus: {
            type: 'mentor',
            id: this.profile.id,
            firstName: this.profile.firstName,
            lastName: this.profile.lastName,
          },
        },
      })
    },
    loadAbsoluteImage(index) {
      return require(`@/assets/img/profile-art-${index}.svg`)
    },
  },
}
